import { updateStep } from '@/api/setters';
import { FormData, Stages, Steps } from '@/api/types';
import {
  getUserType,
  startFormDataLayer,
  startStageDataLayer,
} from '@/helpers/addStageToDataLyer';

import { QueryClient } from '@tanstack/react-query';

interface AppLoaderVDProps {
  data: FormData;
  id: string;
  queryClient?: QueryClient;
}

export const appLoaderHH = async ({ data, id }: AppLoaderVDProps) => {
  const userType = getUserType(data);

  !data.step && updateStep(id, Steps.Step_I_start);
  !data.step && startFormDataLayer(userType);
  !data.step &&
    data.stage === Stages.STAGE_I &&
    startStageDataLayer(data.stage, userType);
};
